<app-search-field [(ngModel)]="query" />

<mat-checkbox
  class="checkbox-filter"
  [color]="'primary'"
  [checked]="allChecked"
  [indeterminate]="isIndeterminate"
  (change)="toggle($event)"
  [labelPosition]="'after'">
  Select all ({{ count() }})
</mat-checkbox>

<div class="checkbox-list">
  @for (checkbox of viewDictionary(); track checkbox.id) {
    <mat-checkbox
      class="checkbox-filter"
      [color]="'primary'"
      [checked]="selectedSet.has(checkbox.id)"
      (change)="toggleOne(checkbox.id)"
      [labelPosition]="'after'">
      {{ checkbox.name }}
    </mat-checkbox>
  }
</div>
